export { default } from './FunnelProduct'
